import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AssetGroupXrefEntity} from './asset.group.xref.entity';

@EntityTable('asset_group', '792a6bb1-1cdc-4b95-ab70-162f9ad6ce78')
export class AssetGroupEntity extends Entity {

    @Column(FieldTypeKind.STRING)
    public name: string;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Transient('asset_group_xref', FieldRelationKind.HAS_MANY, 'assetGroupId', 'aliasId', 'aliasId')
    public assetsXrefs: AssetGroupXrefEntity[];

}
